import React, { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { Grid, Popup } from 'semantic-ui-react';
import { isValidForm, updateDataToObj } from '..';
import { isPatternValid } from '../../../_utilities/validation';
import { IContractCard, IForm, IFormValidation } from '../types';

export const StepFour = (props) => {

    const { inputData, saveData, nextStep, validationData, saveValidationData } = props
    const [outputData, setOutputData] = useState<IForm>(inputData);
    const [valData, setValData] = useState<IFormValidation>(validationData);
    const [limitLeft, setLimitLeft] = useState<number>(parseInt(inputData.contractConditions.totalLimit));
    const [isValid, setIsValid] = useState<boolean>(false);

    const inputChange = (path, value, index = -1, extraKey = '') => {
        const tempData = updateDataToObj(outputData, path, value, index, extraKey);
        setOutputData({ ...tempData });
    }

    const inputBlur = (element, path, index = -1, extraKey = '') => {
        const tempVal = updateDataToObj(valData, path, isPatternValid(element.getAttribute('data-pattern'), element.value), index, extraKey);
        setValData({ ...tempVal });
    }

    const formRef = useRef(null);
    const formSubmit = (e) => {
        e.preventDefault();
        saveData({ ...outputData });
        saveValidationData({ ...valData });
        nextStep(10);
    }

    useEffect(() => {
        calculateLimits();
        setIsValid(isValidForm(formRef.current))
    }, [outputData, valData]);

    const calculateLimits = () => {
        let left: number = parseInt(outputData.contractConditions.totalLimit);
        outputData.contractConditions.contractCards.forEach((card: IContractCard) => {
            if (parseInt(card.cardLimit) > 0)
                left = left - parseInt(card.cardLimit);
        });
        setLimitLeft(left);
    };

    return <div className="m-form__step">

        <h2 className="m-form__header">Konfiguracja Kart</h2>
        <form onSubmit={formSubmit} ref={formRef}>
            <div className="m-form__block">

                <Grid columns={2}>
                    <Grid.Row>
                        <Grid.Column width={9}>
                            <span className="m-form__subheader">Limit ogólny:</span>
                        </Grid.Column>
                        <Grid.Column width={7} textAlign='right'>
                            <span className="m-form__subheader">{`${parseInt((outputData.contractConditions.totalLimit).toString().replace(/_/g, ''))} PLN`}</span>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={9}>
                            <span className="m-form__subheader">Pozostało do rozdysponowania:</span>
                        </Grid.Column>
                        <Grid.Column width={7} textAlign='right'>
                            <div className={`m-form__component color-light ${limitLeft < 0 ? 'is--error' : ''}`}>
                                <span className="m-form__subheader">{`${limitLeft} PLN`}</span>
                                <div className="m-form__component-error">Popraw rozdysponowanie</div>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={9}>
                        </Grid.Column>
                        <Grid.Column width={7} className="m-form__text" textAlign='right'>
                            Rozdysponuj brakującą kwotę lub <button type="button" className="m-form__btn m-form__btn--light" onClick={() => { nextStep(3) }}><span>zmień limit ogólny</span></button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
            <div className="m-form__block">

                <Grid columns={3}>
                    <Grid.Row>
                        <Grid.Column width={3} className="m-form__text text-bold">
                            Numer karty
                        </Grid.Column>
                        <Grid.Column width={5} className="m-form__text text-bold">
                            Limit karty
                        </Grid.Column>
                        <Grid.Column width={7} className="m-form__text with-tooltip text-bold">
                            <span>Numer telefonu komórkowego użytkownika przypisanego do karty</span>
                            <Popup content='Służy do zarządzania kodem autoryzującym transakcje. Na ten numer będą wysyłane komunikaty informujące o aktywacji/blokadzie karty, o zmianie kodu (PIN - w umowie PAN: personal authorisation number), itp. Każda karta musi mieć przypisany jakiś jeden nr telefonu komórkowego. Może być tak, że do wielu kart przypisany jest ten sam nr, wtedy wszystkie komunikaty dotyczące tych kart będą wysyłane na ten jeden nr.' trigger={<i className="icon-info"></i>} />
                        </Grid.Column>
                    </Grid.Row>

                    {outputData.contractConditions.contractCards.map((card, index) => (
                        <Grid.Row className="align-center" key={"rowww"+index}>
                            <Grid.Column width={3} className="m-form__text m-form__text-cell">
                                {`KartaPartner#${card.cardNo}`}
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <div className={`${valData.contractConditions.contractCards[index].cardLimit == false ? 'is--error' : ''}`}>
                                    <div className="m-form__component">
                                        <input
                                            className='smaller'
                                            type='text'
                                            placeholder=""
                                            data-pattern="MIN"
                                            data-required
                                            // name={card}
                                            value={card.cardLimit}
                                            onChange={(e) => {
                                                inputChange('contractConditions.contractCards', e.target.value, index, 'cardLimit');
                                            }}
                                            onBlur={(e) => {
                                                inputBlur(e.target, 'contractConditions.contractCards', index, 'cardLimit');
                                            }}
                                        />
                                    </div>
                                    <div className="m-form__component-error">
                                        {outputData.contractConditions.contractCards[index].cardLimit == '' ? 'Proszę uzupełnić pole' : 'Wartość musi być większa od 99'}
                                    </div>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={7}>
                                <div className={`${valData.contractConditions.contractCards[index].cardPhoneNumber == false ? 'is--error' : ''}`}>
                                    <div className="m-form__component">
                                        <InputMask
                                            mask='48999999999'
                                            className='smaller'
                                            placeholder=''
                                            data-required
                                            data-pattern="PHONE"
                                            // name={card}
                                            value={card.cardPhoneNumber}
                                            onChange={(e) => {
                                                inputChange('contractConditions.contractCards', e.target.value, index, 'cardPhoneNumber');
                                            }}
                                            onBlur={(e) => {
                                                inputBlur(e.target, 'contractConditions.contractCards', index, 'cardPhoneNumber');
                                            }}
                                        />
                                    </div>
                                    <div className="m-form__component-error">
                                        {outputData.contractConditions.contractCards[index].cardPhoneNumber == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    )
                    )}
                </Grid>
            </div>

            <div className="m-form__btns">
                <button type="submit" className="m-form__btn m-form__btn--next" disabled={!isValid || limitLeft!=0}>Przejdź dalej</button>
                <button type="button" className="m-form__btn m-form__btn--back" onClick={() => { nextStep(3) }}>Powrót</button>
            </div>
        </form>

    </div>
}

